import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChairAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"chair_alt"}/>
}
